import React, { memo, useReducer } from 'react';
import { Form } from '@redlink/components/organisms';
import { Space, withPopUp } from '@redlink/components/atoms';
import {FormSection, TextInput, useAlert} from '@redlink/components/molecules';
import { DataEntryModalTemplate } from '@redlink/components/templates';
import { useLocale } from '@redlink/assets/locale';
import { useMutation, changePasswordQuery } from '@redlink/services';
import { initialState, reducer, types } from './store';

export const ProfileChangePasswordPage = withPopUp(
  memo(({ onDismiss }) => {
    const { dictionary } = useLocale();
    const alert = useAlert();

    const [{ password, confirmPassword }, dispatch] = useReducer(
      reducer,
      initialState
    );

    const [changePassword, { loading: changePasswordIsBusy }] = useMutation(
      changePasswordQuery,
      {
        done: () => {
          onDismiss();
          alert.show(dictionary.changePasswordSuccess, { type: 'success' });
        },
      }
    );

    const onChangePasswordPressed = () => {
      if (password !== confirmPassword) {
        alert.show(dictionary.passwordNotEqualWithConfirm, { type: 'error' });
        return;
      }

      changePassword({ newPassword: password });
    };

    return (
      <DataEntryModalTemplate>
        <Form
          isBusy={changePasswordIsBusy}
          actions={[
            {
              title: dictionary.cancel,
              variant: 'secondary',
              onPress: onDismiss,
            },
            {
              title: dictionary.changePassword,
              variant: 'primary',
              onPress: onChangePasswordPressed,
            },
          ]}
        >
          <FormSection title={dictionary.changePassword}>
            <TextInput
              require
              title={dictionary.newPassword}
              value={password}
              onChangeText={(value) =>
                dispatch({ type: types.SET_PASSWORD, payload: value })
              }
              secureTextEntry
            />
            <Space size={16} />
            <TextInput
              require
              title={dictionary.confirmPassword}
              value={confirmPassword}
              onChangeText={(value) =>
                dispatch({ type: types.SET_CONFIRM_PASSWORD, payload: value })
              }
              secureTextEntry
            />
          </FormSection>
        </Form>
      </DataEntryModalTemplate>
    );
  })
);
